module.exports = __webpack_public_path__ + "static/media/i_featured_1с.781d57c9.svg";